module.exports = __webpack_public_path__ + "assets/img/181c7e01523aa71f7f2a36c9b9c47275.svg";